<template>
  <div id="paypage">
    <loading v-if="isLoading"></loading>
    <a-layout style="height: 100vh;">
      <a-layout-header>
        <a-statistic title="Payment Amount" :value="amount">
          <template #prefix>₹</template>
        </a-statistic>
      </a-layout-header>

      <a-layout-content>
        <a-space direction="vertical" style="width: 100%">
          <!-- 唤醒 -->
          <a-space direction="vertical" style="width: 100%" :size="'small'">
            <a-card v-if="ct_config.paytm">
              <div class="paylogo">
                <a-icon :component="paytmlogoSvg" />
                <a-button :loading="paytm_paynow_loading" type="primary" size="large" @click="paynow('paytm')">Pay
                  Now</a-button>
                  <img src="/images/click.png" class="click-tip"/>
              </div>
            </a-card>
            <a-card v-if="ct_config.phonepe">
              <div class="paylogo">
                <a-icon :component="wakupphonepeSvg" />
                <a-button :loading="phonepe_paynow_loading" type="primary" size="large" @click="paynow('phonepe')">Pay
                  Now</a-button>
              </div>
            </a-card>

            <a-card v-if="ct_config.gpay">
              <div class="paylogo">
                <a-icon :component="wakupgpaySvg" />
                <a-button :loading="gpay_paynow_loading" type="primary" size="large" @click="paynow('gpay')">Pay
                  Now</a-button>
              </div>
            </a-card>

            <a-card v-if="ct_config.mobikwik">
              <div class="paylogo">
                <a-icon :component="wakupmobikwikSvg" />
                <a-button :loading="mobikwik_paynow_loading" type="primary" size="large" @click="paynow('mobikwik')">Pay
                  Now</a-button>
              </div>
            </a-card>

            <a-card v-if="ct_config.upi">
              <div class="paylogo">
                <a-icon :component="UPISvg" />
                <a-button :loading="upi_paynow_loading" type="primary" size="large" @click="paynow('upi')">Pay
                  Now</a-button>
              </div>
            </a-card>

          </a-space>

          <a-collapse v-model:activeKey="activeKey" accordion expandIconPosition="right">
            <a-collapse-panel key="1" v-if="ct_config.copy">
              <span slot="header">Copy UPI ID<span style="color: red;"> ( Unable to pay please use )</span></span>
              <!-- 复制 UPI -->
                <a-tooltip>
                  <span style="color: red; font-weight: bold;">Step 1: Transfer </span>
                  <span style="color: #d375de;font-weight: bold;">₹ {{ amount }} to the following upi</span>
                </a-tooltip>
                <a-card>
                  <div class="paylogo">
                    <span class="copy-span">{{ orderinfo.collection_upi_id }}</span>
                    <a-button class="copy-btn" type="primary" size="large"
                      :data-clipboard-text="orderinfo.collection_upi_id" @click="onCopy('UPI ID')">
                      Copy</a-button>
                  </div>
                </a-card>
                <a-card>
                  <div class="paylogo">
                    <span class="copy-span">Amount: {{ amount }}</span>
                    <a-button class="copy-btn" type="primary" size="large" :data-clipboard-text="amount"
                      @click="onCopy('amount')">
                      Copy</a-button>
                  </div>
                </a-card>

                <a-tooltip>
                  <span style="color: red; font-weight: bold;">Step 2: Submit Ref No/Reference No/UTR</span>
                </a-tooltip>

                <a-card>
                  <div class="paylogo">
                    <a-input style="margin-left: -1rem;" placeholder="UTR(UPI Ref.ID) must be 12 digits" v-model="utr" ref="backutr"
                      type="number" />
                  </div>
                </a-card>

                <a-card class="copy-submit-utr">
                  <a-button class="copy-submitutr" type="primary" size="large" @click="handleOk">
                    Submit Utr</a-button>
                </a-card>
                <span class="label" style="color: red;">After the payment is successful, you must coming back here to
                  submit
                  the Ref/UTR No.(12 digits) Only then your money be reached to the account.</span>
                <p class="how_title" @click="utrinfo">How to find the UTR number? Click here. >></p>
            </a-collapse-panel>
            <a-collapse-panel key="2" header="QRCode" v-if="ct_config.qr">
              <!-- 扫码 -->
              <div class="qrcode">
                <span class="title">Scan QR from your UPI App</span>
                <span class="label">Or take a screenshot and save then pay through the app</span>
                <qrcode-vue :value="qrlink" :size="size" level="H" />
                <span class="tip">Don't use the same QR code to pay multiple times</span>
                <span class="quick">Scan code supported APP</span>
                <a-button-group size="large" style="margin-top: 5px;">
                  <a-button type="dashed" class="quickapplink" @click="quickapp('phonepe')">
                    <a-icon :component="phonepeSvg" />
                  </a-button>
                  <a-button type="dashed" class="quickapplink" @click="quickapp('gpay')">
                    <a-icon :component="Google_PaySvg" />
                  </a-button>
                  <a-button type="dashed" class="quickapplink" @click="quickapp('mobikwik')">
                    <a-icon :component="mobikwikSvg" />
                  </a-button>
                  <a-button type="dashed" class="quickapplink" @click="quickapp('upi')">
                    <a-icon :component="UPISvg" />
                  </a-button>
                </a-button-group>
              </div>
            </a-collapse-panel>
          </a-collapse>
        </a-space>
      </a-layout-content>

      <a-layout-footer>
        <div>
          <div>
            <a-icon type="safety-certificate" :style="{ fontSize: '16px', color: '#52c41a' }" />
            100% Secure Payments Powered by UPI
          </div>
          <div>
            <a-icon type="mail" :style="{ fontSize: '16px', color: 'red' }" />
            Fraud Complaints: <a href="mailto:upaycomplaint@gmail.com">upaycomplaint@gmail.com</a>
          </div>
        </div>
      </a-layout-footer>
    </a-layout>

    <a-modal title="Payment Checking Failed" :visible="utrmodal" :okText="'Submit UTR'"
      :cancelText="'Pay failed, try again'" @ok="handleOk" :closable="false" @cancel="handleCancel"
      :confirm-loading="utrconfirm_loading">
      <p>Please provider UTR(UPI Ref.ID) must be 12 digits</p>
      <a-input placeholder="UTR(UPI Ref.ID) must be 12 digits" v-model="utr" type="number" />
    </a-modal>
  </div>
</template>
<script>
import paytmlogoSvg from '../assets/Paytm_Logo.svg';
import Google_PaySvg from '../assets/Google_Pay.svg';
import mobikwikSvg from '../assets/mobikwik.svg';
import wakupphonepeSvg from '../assets/wakup_phonepe.svg';
import wakupgpaySvg from '../assets/wakup_gpay.svg';
import wakupmobikwikSvg from '../assets/wakup_mobikwik.svg';
import phonepeSvg from '../assets/phonepe.svg';
import UPISvg from '../assets/UPI.svg';
import Loading from '../components/Loading.vue';
import QrcodeVue from 'qrcode.vue';
import { Modal } from 'ant-design-vue';
import { execute_order, getorder, backfillutr, cwquery, process } from '@/requests/api';
import Clipboard from 'clipboard';


export default {
  components: {
    QrcodeVue,
    Loading,
  },
  data() {
    return {
      paytmlogoSvg,
      Google_PaySvg,
      mobikwikSvg,
      phonepeSvg,
      UPISvg,
      wakupgpaySvg,
      wakupphonepeSvg,
      wakupmobikwikSvg,
      qrlink: 'https://siipay.in',
      size: 150,
      paytm_paynow_loading: false,
      gpay_paynow_loading: false,
      phonepe_paynow_loading: false,
      mobikwik_paynow_loading: false,
      upi_paynow_loading: false,
      utrconfirm_loading: false,
      isLoading: true,
      queryinterval: "",
      orderon: "",
      amount: "- -",
      utrmodal: false,
      utr: "",
      ct_config: {},
      // 订单号
      orderno: "",
      orderinfo: {},
      activeKey: [2]
    };
  },
  watch: {
    utr(val) {
      if (val.length > 12) {
        this.utr = val.slice(0, 12);
      }
    }
  },

  created() {
    this.orderno = this.$route.params.orderno;
    this.postprocess("created");
    if (!this.orderno) {
      this.warning('the order does not exist, please return to the merchant website to check');
    } else {
      this.loadingOrder();
    }
  },
  mounted() {
    this.worker = new Worker('/js/worker.js');
    this.worker.postMessage({
      orderno: this.orderno
    });
    this.worker.addEventListener('message', (e) => {
      if (e.data.type === 'success') {
        this.success("payment successful");
        this.worker.terminate();
      }
    });
  },
  methods: {
    utrinfo() {
      const h = this.$createElement;
      this.$info({
        title: 'How to find the UTR No.',
        content: h('div', { class: 'utrinfo-div' }, [
          h('p', { class: 'utrinfo-p' }, 'Paytm'),
          h('img', { attrs: { src: '/images/paytm-1.png' }, class: 'utrinfo-img' }),
          h('img', { attrs: { src: '/images/paytm-2.png' }, class: 'utrinfo-img' }),
          h('p', { class: 'utrinfo-p' }, 'Gpay'),
          h('img', { attrs: { src: '/images/gpay.png' }, class: 'utrinfo-img' }),
          h('p', { class: 'utrinfo-p' }, 'BHIM'),
          h('img', { attrs: { src: '/images/BHIM.png' }, class: 'utrinfo-img' }),
          h('p', { class: 'utrinfo-p' }, 'amazon'),
          h('img', { attrs: { src: '/images/amazon.png' }, class: 'utrinfo-img' }),
        ]),
        onOk() { },
      });
    },
    onCopy(text) {
      let that = this;
      let clipboard = new Clipboard('.copy-btn');
      clipboard.on('success', () => {
        that.$message.success("Copy " + text + " successful");
        clipboard.destroy();
        // that.$message.destroy();
      });
    },
    handleOk() {
      let that = this;
      if (this.utr.length != 12) {
        that.$message.warning("Please provider UTR(UPI Ref.ID) must be 12 digits");
        return;
      }
      that.utrconfirm_loading = true;
      backfillutr({
        orderno: that.orderno,
        upi_ref_no: that.utr
      }).then((res) => {
        if (res.code == 200) {
          that.utrconfirm_loading = false;
          that.utrmodal = false;
          if (res.data.status === "success") {
            that.success("payment successful");
          } else {
            that.submit_utr_success();
          }
        } else {
          that.$message.warning(res.errmsg);
        }
      })
    },
    handleCancel() {
      this.utrmodal = false;
    },
    warning(message) {
      let that = this;
      this.$warning({
        title: 'Error',
        content: message,
        onOk: () => {
          window.location.href = this.orderinfo.callback_url;
        }
      });
    },
    paynow_tips() {
      let that = this;
      setTimeout(() => {
        that.$confirm({
          title: 'Tips',
          cancelText: 'Submit Utr',
          okText: 'Change payment method',
          content: 'If you cannot complete the payment, please copy the upi payment, and after the payment is completed, if there is no prompt success, please submit UTR',
          onOk: () => {
            
          },
          onCancel: () => {
            that.activeKey = [1];
          }
        });
      }, 3000);
    },
    try_agent(message) {
      let that = this;
      this.$warning({
        title: 'please try agent',
        content: message,
        onOk: () => {
          that.get_orderinfo();
        }
      });
    },
    success(msg) {
      let that = this;
      Modal.success({
        title: 'Payment Checking Success',
        okText: 'Return to App',
        content: msg,
        onOk: () => {
          window.location.href = this.orderinfo.callback_url;
        }
      });
    },
    timeout(msg) {
      let that = this;
      Modal.warning({
        title: 'Payment Timeout',
        okText: 'Return to App',
        content: msg,
        onOk: () => {
          window.location.href = this.orderinfo.callback_url;
        }
      });
    },
    submit_utr_success() {
      const h = this.$createElement;
      Modal.success({
        title: 'Submit Success',
        okText: 'Return to App',
        content: h('div', {}, [
          h('p', 'We will confirm your payment shortly '),
          h('p', 'Please await a moment'),
        ]),
        onOk: () => {
          window.location.href = this.orderinfo.callback_url;
        }
      });
    },
    paynow(paytype) {
      let that = this;
      this.paynow_loading(paytype, true);
      window.location.href = this.get_app_wakeup_prefix(paytype) + this.get_wakeup_params(paytype);
      setTimeout(() => {
        setTimeout(() => {
          cwquery({
            orderno: that.orderno
          }).then((res) => {
            if (res.code == 200) {
              if (res.data.status === "success") {
                that.success("payment successful");
              }
            }
          });
        }, 1500);
        that.paynow_tips();
        // Modal.confirm({
        //   title: 'Payment Checking',
        //   content: 'Are you finish paid ?',
        //   okText: 'I have paid',
        //   cancelText: 'Pay failed, try again',
        //   onOk() {
        //     return new Promise((resolve, reject) => {
        //       //resolve 关闭
        //       //reject 不关闭
        //       setTimeout(() => {
        //         cwquery({
        //           orderno: that.orderno
        //         }).then((res) => {
        //           if (res.code == 200) {
        //             if (res.data.status === "success") {
        //               that.success("payment successful");
        //               resolve();
        //             }
        //             reject()
        //           }
        //         });
        //       }, 1500);
        //     }).catch(
        //       //结果是 reject 不关闭时到这里处理
        //       () => {
        //         that.utrmodal = true;
        //       }
        //     );

        //   },
        // });
        that.paynow_loading(paytype, false);
      }, 1200);
    },
    get_orderinfo() {
      let that = this;
      getorder({
        orderno: that.orderno
      }).then(res => {
        if (res.code === 200) {
          that.orderinfo = res.data;
          that.ct_config = res.data.wakeup_params.ct_config;
          that.qrlink = that.get_app_wakeup_prefix("qr") + that.get_wakeup_params("qr");
          that.activeKey = res.data.wakeup_params.ct_config.show_default_setting || [2];
          that.amount = res.data.amount;
          if (res.data.status === 'success') {
            that.success("payment successful");
            return;
          }
          if (res.data.status === 'timeout') {
            that.timeout("payment timeout");
            return;
          }
          if (Number(that.amount) > Number(2000)) {
            that.ct_config.qr = false;
          }
          execute_order({
            orderno: that.orderno
          }).then(res => {
            if (res.code === 200) {
              that.isLoading = false;
            } else {
              that.warning(res.errmsg);
            }
          }).catch(error => {
            console.log(error);
            that.try_agent("cash register request error, please try agent");
          })
        } else {
          that.try_agent(res.errmsg);
        }
      }).catch(error => {
        console.log(error);
        that.try_agent("cash register request error, please try agent")
      });
    },
    postprocess(msg) {
      console.log(msg);
      // process({orderno: this.orderno, process: msg});
    },
    loadingOrder() {
      this.postprocess("enter_cash");
      this.get_orderinfo();
    },
    get_app_wakeup_prefix(paytype) {
      let u = navigator.userAgent;
      // let isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      switch (paytype) {
        case 'paytm':
          return "paytmmp://";
        case 'gpay':
          return "gpay://upi/";
        case 'phonepe':
          return "phonepe://";
        default:
          return "upi://";
      }
    },
    get_wakeup_params(paytype) {
      switch (paytype) {
        case 'paytm':
          return this.orderinfo.wakeup_params.paytm;
        case 'gpay':
          return this.orderinfo.wakeup_params.gpay;
        case 'phonepe':
          return this.orderinfo.wakeup_params.phonepe;
        case 'qr':
          return this.orderinfo.wakeup_params.qr;
        default:
          return this.orderinfo.wakeup_params.upi;
      }
    },
    paynow_loading(paytype, isLoading) {
      switch (paytype) {
        case 'paytm':
          this.paytm_paynow_loading = isLoading;
          break;
        case 'gpay':
          this.gpay_paynow_loading = isLoading;
          break;
        case 'phonepe':
          this.phonepe_paynow_loading = isLoading;
          break;
        case 'mobikwik':
          this.phonepe_paynow_loading = isLoading;
          break;
        default:
          this.upi_paynow_loading = isLoading;
          break;
      }
    },
    quickapp(paytype) {
      return;
      switch (paytype) {
        case 'paytm':
          window.location.href = "paytmmp://pay";
          break;
        case 'gpay':
          window.location.href = "gpay://upi/pay";
          break;
        case 'phonepe':
          window.location.href = "phonepe://pay";
          break;
        case 'mobikwik':
          window.location.href = "mobikwik://open";
          break;
        default:
          window.location.href = "upi://pay";
          break;
      }
      this.paynow_tips();
    },
    query() {
      let that = this;
      cwquery({
        orderno: this.orderno
      }).then((res) => {
        if (res.code == 200) {
          if (res.data.status === "success") {
            this.$destroyAll();
            that.success("payment successful");
            return;
          }
        }
      });
    }
  }
};
</script>
<style scoped>
.click-tip {
  position: absolute;
  right: 6px;
  top: 19px;
  width: 2.5rem;
  animation: scaleDraw-839238be 3s ease-in-out infinite;
}
.utrinfo-div {
  height: 27rem;
  overflow: scroll;
}

.utrinfo-p {
  font-family: lato;
  font-weight: 600;
  color: #054384;
  text-align: center;
}

.utrinfo-img {
  width: 100%;
}

.how_title {
  text-align: center;
  margin-top: 20px;
  font-size: 13px;
  font-family: lato;
  font-weight: bolder;
  color: #ff5e00;
  line-height: 14px;
}

.copy-submit-utr {
  text-align: center;
}

.copy-submitutr {
  width: 15rem;
}

.copy-btn {
  width: 4rem;
  height: 2rem;
}

.copy-span {
  font-size: 0.8rem;
}

#paypage>>>.ant-card-body {
  padding: 10px 20px !important;
}

.quickapplink {
  height: 3.2rem !important;
  padding: 0 12px !important;
  font-size: 2.5rem !important;
  line-height: 3rem !important;
}

.qrcode {
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 28px;
}

.qrcode .title,
.quick {
  font-size: 1.1rem;
  font-weight: 600;
}

.qrcode .label {
  font-size: 0.8rem;
  color: rgb(0 0 0 / 53%);
  font-weight: 550;
}

.qrcode .tip {
  font-size: 0.9rem;
  color: red;
}

.paylogo {
  font-size: 7rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

#paypage .ant-layout-header {
  background: #2681c3;
  color: #fff;
  height: unset;
  padding: 36px 0 5px 18px;
}

#paypage>>>.ant-statistic-content {
  font-size: 32px;
  font-weight: 700;
  color: #fff;
}

#paypage>>>.ant-statistic-title {
  color: #fff;
}

#paypage .ant-layout-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  z-index: 99;
}

#paypage .ant-layout-content {
  padding: 5px;
  z-index: 999;
}
</style>
